import { useApiLoadingStore } from "../store/apiLoadingStore";

export function trackApiStart({ silent = false } = {}) {
  if (silent) return;
  useApiLoadingStore.getState().start();
}

export function trackApiEnd({ silent = false } = {}) {
  if (silent) return;
  useApiLoadingStore.getState().end();
}

export async function withApiTracking(fn, { silent = false } = {}) {
  trackApiStart({ silent });
  try {
    return await fn();
  } finally {
    trackApiEnd({ silent });
  }
}
